import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  container: {
    fontSize: '3rem',
    display: 'flex',
    flexDirection: 'column',
  },
}))
